import transform from 'lodash/transform';
import isEmpty from 'lodash/isEmpty';
import isPlainObject from 'lodash/isPlainObject';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const removeEmptyValuesFromObject = (obj: object): any =>
  transform(
    obj,
    (result, value, key) => {
      if (isPlainObject(value)) {
        const cleaned = removeEmptyValuesFromObject(value);
        if (!isEmpty(cleaned)) {
          result[key] = cleaned;
        }
      } else if (value !== '' && value !== null && value !== undefined) {
        result[key] = value;
      }
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    {} as any,
  );
